import { Button, Icon } from "grabcad-ui-elements";
import { Banner, BannerContent } from "./SsoStyledComponents";
import { useContext } from "react";
import { ApplicationContext } from "../../../components/ApplicationProvider";
import { streamLineProURL } from "../../../utils/constants";
import { useMutation } from "@apollo/client";
import { CREATE_EVENT } from "../../../graphql/Mutations/Event";
import { useCompanyAsAdminQuery } from "../../../graphql";
import {
    EventCategory,
    METRIC_EVENT_CATALOG,
    MetricEventKey,
} from "@grabcad/company-server-shared/dist/types";

export const InfoBanner = () => {
    const { t } = useContext(ApplicationContext);
    const { company } = useCompanyAsAdminQuery();
    const [triggerCreateEvent] = useMutation(CREATE_EVENT);

    const handleClick = () => {
        // Always perform UI action first
        window.open(streamLineProURL, "_blank");

        // Fire-and-forget analytics
        if (!company?.internal) {
            const { action, description } = METRIC_EVENT_CATALOG[MetricEventKey.GET_STREAMLINE_PRO];

            void triggerCreateEvent({
                variables: {
                    events: [
                        {
                            event: EventCategory.GC_CONTROL,
                            action,
                            description,
                        },
                    ],
                },
            }).catch((err) => {
                console.error("Failed to log event:", err);
            });
        }
    };

    return (
        <Banner>
            <BannerContent>
                <Icon size="large" name="info circle" style={{ color: "#4183c4" }} />
                <span>{t("advanced_settings.sso_banner")}</span>
            </BannerContent>
            <Button onClick={handleClick}>{t("advanced_settings.get_streamline_pro")}</Button>
        </Banner>
    );
};
